module.exports = __webpack_public_path__ + "static/media/scene4_furba1.c78eb42a.wav";